import { Box, useTheme, Divider } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Typography } from "@lyfegen-platform/react-common";

interface OrganizationUsersProps {
	title: string;
	paddingX: number;
	paddingTop: number;
}

const InfoDivider: React.FC<OrganizationUsersProps> = ({ title, paddingX, paddingTop }) => {
	const {
		palette: {
			widgetHeaderText: { main },
		},
		typography: { pxToRem },
	} = useTheme();
	const { t } = useTranslation();

	return (
		<Box width="100%" paddingX={paddingX} paddingTop={paddingTop} display="flex" justifyContent="space-between" alignItems="center">
			<Typography type="h7" style={{ color: main }}>
				{t(title)}
			</Typography>
			<Divider style={{ flexGrow: 1, margin: pxToRem(15), backgroundColor: main }} />
		</Box>
	);
};

export default InfoDivider;
